import React from 'react';
import classNames from 'classnames';

import FormTextField from '../formTextField/FormTextField';
import FormTextAreaField from '../formTextAreaField/FormTextAreaField';
import FormSelectField from '../formSelectField/FormSelectField';
import MyCalendar from '../../calendar/Calendar';
import ServicesCategory from '../servicesCategory/ServicesCategory';

import { ReactComponent as OtherLinkIcon } from './otherLink.svg';

import './FirstPage.css';
import '../ProjectCreationForm.css';

const commitmentLevels = ['Intermittent', 'Part-time', 'Full-time'];

const budgets = [
    'By agreement',
    '£1 - £100',
    '£100 - £250',
    '£250 - £500',
    '£500 - £1,000',
    '£1,000 - £2,500',
    '£2,500 - £5,000',
    '£5,000 - £10,000',
    '£10,000+',
];

const FirstPage = props => {
    const jobPostClass = classNames({
        formFieldWrapper: true,
        formInputWrapper: true,
        'jobPost-wrap': true,
        'field-error': props.errors.title && props.touched.title,
    });

    const jobPostInputClass = classNames({
        jobPost: true,
        jobPost_small: props.values.title,
    });

    const jobDescrClass = classNames({
        formFieldWrapper: true,
        formTextAreaWrapper: true,
        'jobDescr-wrap': true,
        'field-error': props.errors.description && props.touched.description,
    });

    const jobDescrTextareaClass = classNames({
        jobDescr: true,
        jobDescr_small: props.values.description,
    });

    const briefClass = classNames({
        formFieldWrapper: true,
        formInputWrapper: true,
        'field-error': props.errors.brief && props.touched.brief,
    });

    const budgetClass = classNames({
        budget: true,
        'header-error':
            (props.errors.deadline && props.touched.deadline) ||
            (props.errors.budget && props.touched.budget) ||
            (props.errors.commitmentLevel && props.touched.commitmentLevel),
    });

    return (
        <div className="firstPage">
            <div className="oneLineFieldsWrap">
                <div className={jobPostClass}>
                    <div className="jobPost-text-wrap">
                        {props.values.title && (
                            <div className="headerTitle small">Name job post</div>
                        )}
                        <FormTextField
                            placeholder="Name job post"
                            name="title"
                            maxLength={55}
                            {...props}
                            className={jobPostInputClass}
                        />
                    </div>
                    <div className="symbol-limit jobPost__symbol-limit">
                        {`${props.values.title.length}/55`}
                    </div>
                </div>
                <div className={briefClass}>
                    <OtherLinkIcon />
                    <FormTextField
                        isLink
                        placeholder="Link to the brief"
                        name="brief"
                        className="briefLink"
                        {...props}
                    />
                </div>
            </div>
            <div className="fieldWrapper descr">
                <div className={jobDescrClass}>
                    {props.values.description && (
                        <div className="headerTitle small">Description</div>
                    )}
                    <FormTextAreaField
                        placeholder="Description"
                        name="description"
                        maxLength={500}
                        {...props}
                        className={jobDescrTextareaClass}
                    />
                    <div className="jobDescr__symbol-limit_wrap">
                        <div className="symbol-limit jobDescr__symbol-limit">
                            {`${props.values.description.length}/500`}
                        </div>
                    </div>
                </div>
            </div>
            <div className="fieldWrapper categories">
                <ServicesCategory
                    name="category"
                    values={props.values}
                    setValues={props.setValues}
                    errors={props.errors}
                    touched={props.touched}
                    handleChange={props.handleChange}
                />
            </div>
            <div className="fieldWrapper deadlines">
                <h2 className={budgetClass}>Budget and deadlines</h2>
                <div className="selectsCondition">
                    <FormSelectField name="budget" header="Budget" list={budgets} {...props} />
                    <FormSelectField
                        name="commitmentLevel"
                        header="Commitment level"
                        list={commitmentLevels}
                        {...props}
                    />
                    <MyCalendar
                        name="deadline"
                        touched={props.touched}
                        errors={props.errors}
                        values={props.values}
                        setValues={props.setValues}
                    />
                </div>
            </div>
        </div>
    );
};

export default FirstPage;
